export const CODE_NAME_REGEX = /^[a-zA-Z_$][a-zA-Z_$0-9]*$/;
